module.exports = __webpack_public_path__ + "bed-quilt3-empty.88fa9260.png";